export default __webpack_public_path__ + "static/media/0xb33eaad8d922b1083446dc23f610c2567fb5180f.2479e47e.png";